"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultRoles = exports.RoleType = void 0;
var RoleType;
(function (RoleType) {
    RoleType["TEAM"] = "team";
    RoleType["API_KEY"] = "api_key";
    RoleType["UNIVERSAL"] = "universal";
})(RoleType = exports.RoleType || (exports.RoleType = {}));
var DefaultRoles;
(function (DefaultRoles) {
    DefaultRoles["OWNER"] = "Owner";
    DefaultRoles["PAYMENT_INTEGRATION"] = "Payment integration";
    DefaultRoles["WAREHOUSE_MANAGER"] = "Warehouse Manager";
    DefaultRoles["WAREHOUSE_PICKER"] = "Warehouse Picker";
    DefaultRoles["PARTNER"] = "Partner";
    DefaultRoles["PARTNER_INTEGRATION"] = "Partner integration";
    DefaultRoles["MANAGED_COMPANY"] = "Managed company";
    DefaultRoles["SALES_PERSON"] = "Sales person";
    DefaultRoles["SALES_PERSON_OB"] = "Sales Person OB";
    DefaultRoles["SALES_AGENT"] = "Sales agent";
    //role for b2b testers
    DefaultRoles["B2B"] = "B2B";
})(DefaultRoles = exports.DefaultRoles || (exports.DefaultRoles = {}));
